import * as React from 'react'

const TrashBlueIcon = (props: { className?: string; onClick?: (e: any) => void }) => {
  return (
    <svg
      className={props.className}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 14.2222C2 15.2002 2.8999 16 4 16H11.9995C13.0996 16 13.9995 15.2002 13.9995 14.2222V3.55566H2V14.2222ZM14.9995 0.888672H11.4995L10.4995 0H5.5L4.5 0.888672H1V2.6665H14.9995V0.888672ZM4.99854 13.3335V5.3335H5.99854V13.3335H4.99854ZM9.99805 5.3335V13.3335H10.998V5.3335H9.99805Z'
        fill='none'
      />
    </svg>
  )
}

export default TrashBlueIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/TrashBlueIcon.tsx